export default __webpack_public_path__ + "static/media/Keurig verzorgde lekkere hapjes.36e3dd06.jpg";